
export default  {
    bindings: {
      page: '='
    },
    controller: 'pageContentGenericController',
    template: require('../views/pageContent.singleText.html')
  };
  


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/components/pageContent.singleText.component.js